import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.isHoveringCollapsible}}\n  <div role=\"button\" type=\"button\" class=\"collapsible-toggle\" style={{this.computedStyle}} {{on \"click\" this.toggleOpen}}></div>\n{{/if}}", {
  moduleName: "@intercom/embercom-prosemirror-composer/components/tools/collapsible-toggle.hbs"
});